import Vue from "vue";
import Vuex from "vuex";
import user from "@/store/module/user";
import api from "@/api/index";
import dayjs from "dayjs";
import { Notification } from "element-ui";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    get clientHeight() {
      return document.documentElement.clientHeight;
    },
    userInfo: {},
    unitInfo: {},
    unitAssetsInfo: {},
    departProper: {},
    ORG: {},
    roleMenu: "",
    permission: {},
    operation_permission: [],
    globalYear: dayjs()
      .subtract(1, "year")
      .format("YYYY")
  },
  mutations: {
    SET_USERINFO(state, obj) {
      state.userInfo = obj;
    },
    SET_UNITINFO(state, obj) {
      state.unitInfo = obj;
    },
    SET_ASSETSINFO(state, obj) {
      state.unitAssetsInfo = obj;
    },
    SET_DEPARTPROPER(state, obj) {
      state.departProper = obj;
    },
    SET_MENU(state, obj) {
      state.roleMenu = obj.split(",");
    },
    RESET_STATE(state) {
      state.userInfo = {};
      state.unitInfo = {};
      state.unitAssetsInfo = {};
      state.departProper = {};
      state.roleMenu = "";
    },
    SET_ORG(state, obj) {
      state.org = obj;
    },
    SET_ROLE_PERMISSION(state, obj) {
      state.permission = obj && obj[0].menu_operation;
    },
    SET_OPERATION_PERMISSION(state, obj) {
      state.operation_permission = obj;
    },
    SET_GLOBAL_YEAR(state, obj) {
      state.globalYear = obj;
    }
  },
  actions: {
    login(commit, obj) {
      return new Promise((resolve, reject) => {
        api.login(obj).then(res => {
          if (Number(res.error_no) === 0) {
            localStorage.setItem("token", res.token);
            localStorage.setItem("userId", res.data.id);
            resolve(res);
          } else {
            Notification({
              title: "温馨提示",
              dangerouslyUseHTMLString: true,
              type: "error",
              message: res.error_msg,
              position: "bottom-right"
            });
            reject(res);
          }
        })
          .catch(err => {
            reject(err)
          })
      });
    },
    telLogin(commit, obj) {
      return new Promise((resolve, reject) => {
        api.telLogin(obj).then(res => {
          if (Number(res.error_no) === 0) {
            localStorage.setItem("token", res.token);
            localStorage.setItem("userId", res.data.id);
            resolve(res);
          } else {
            Notification({
              title: "温馨提示",
              dangerouslyUseHTMLString: true,
              type: "error",
              message: res.error_msg,
              position: "bottom-right"
            });
            reject(res);
          }
        })
          .catch(err => {
            reject(err)
          })
      });
    },
    // 管理员切换单位
    changeUnitInfo({ commit }, id) {
      return new Promise(resolve => {
        api.getUnitInfo({
          params: {
            unit_id: id
          }
        }).then(res => {
          if (res.error_no == 0) {
            if (typeof res.data !== "string" && res.data.father_property_type !== null) {
              commit("SET_UNITINFO", res.data);
            }
            resolve(res.data);
          } else {
            resolve(res.error_msg);
          }
        });
      });
    },
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        api
          .getUser({
            params: {
              user_id: localStorage.getItem("userId")
            }
          })
          .then(res => {
            if (res.error_no === 0) {
              commit("SET_USERINFO", res.data);
            } else {
              Notification({
                title: "温馨提示",
                dangerouslyUseHTMLString: true,
                type: "error",
                message: res.error_msg,
                position: "bottom-right"
              });
            }
            resolve();
          })
          .catch(err => {
            reject(err)
          })
      });
    },
    getUnitInfo({ commit, state }) {
      return new Promise(resolve => {
        api
          .getUnitInfo({
            params: {
              unit_id: state.userInfo.unit_id
            }
          })
          .then(res => {
            commit("SET_UNITINFO", res.data);
            resolve(res.data);
          });
      });
    },
    getUnitAssetsInfo({ commit, state }) {
      return new Promise(resolve => {
        api
          .getUnitExt({
            params: {
              unit_id: state.unitInfo.id
            }
          })
          .then(res => {
            commit("SET_ASSETSINFO", res.data);
            resolve(res.data);
          });
      });
    },
    getCoType({ commit }, obj) {
      return new Promise(resolve => {
        api
          .getCoType({
            params: obj
          })
          .then(data => {
            commit("SET_DEPARTPROPER", data.data);
            resolve(data.data);
          });
      });
    },
    getAllOrg({ commit }, obj) {
      return new Promise(resolve => {
        api.getOrg(obj).then(res => {
          commit("SET_ORG", res.data);
          resolve(res.data);
        });
      });
    },
    getRolePermission({ commit, state }) {
      return new Promise((resolve, reject) => {
        api
          .getRole({
            params: {
              user_id: 0
            }
          })
          .then(res => {
            if (res) {
              let role_permission = res.data.filter(o => {
                return state.userInfo.role === o.id;
              });
              commit("SET_ROLE_PERMISSION", role_permission);
              resolve();
            }
          })
          .catch(err => {
            reject(err);
          })
      });
    }
  },
  modules: {
    user
  }
});
